let isMobileMenuOpen = false;

const navbar = document.querySelector(".v_navbar");
if (navbar) {
  const burgerMenu = document.getElementById("v_navbar__burger_menu");
  const burgerMenuClickableZone = document.getElementById(
    "v_navbar__burger_menu_clickable_zone"
  );
  const overlay = document.getElementById("v_navbar__burger_menu_open");
  const logo = document.querySelector("#v_navbar__logo");
  const firstCache = document.querySelector("#v_navbar__burger_menu_cache_1");
  const secondCache = document.querySelector("#v_navbar__burger_menu_cache_2");

  burgerMenuClickableZone?.addEventListener("click", function () {
    burgerMenu.classList.toggle("close");
    overlay.classList.toggle("overlay");
    logo.classList.toggle("v_navbar__logo_mask");
    setTimeout(() => {
      firstCache.classList.toggle("v_navbar__burger_transition");
      secondCache.classList.toggle("v_navbar__burger_transition");
    }, 300);
    if (
      Array.from(logo.classList).includes("v_navbar__logo_black") &&
      isMobileMenuOpen === false
    ) {
      logo.classList.toggle("v_navbar__logo_black");
    }
    if (isMobileMenuOpen === true && window.scrollY > navbar.offsetHeight) {
      logo.classList.toggle("v_navbar__logo_black");
    }
    isMobileMenuOpen = !isMobileMenuOpen;

    // deactivate overflow y for mobile
    if (isMobileMenuOpen) {
      document.documentElement.style.overflowY = "hidden";
    } else {
      document.documentElement.style.overflowY = "auto";
    }
  });
}
